export default {
    _findBtn       : null, 
    _backBtn       : null,
    _page1Holder   : null, 
    _page2Holder   : null, 
    _sectionInvoice: null, 
    _form          : null, 

    init() {
        this._findBtn        = document.querySelector("[data-power-find]");
        this._backBtn        = document.querySelector("[data-power-back]");
        this._page1Holder    = document.querySelector("[data-power-userInfo]");
        this._page2Holder    = document.querySelector("[data-power-page2]");
        this._sectionInvoice = document.querySelector("[data-power-invoice]");
        this._form = document.getElementById('powerProduct--order');

        const showbuttons = document.querySelectorAll("[data-showup]");
        const showtargets = document.querySelectorAll("[data-showup-target]");

        if(showbuttons.length){
            for (const showbtn of showbuttons) {
                if (showbtn.value == 1) {
                    for (const showtarget of showtargets) {
                        const toggleClass = showtarget.classList[0] + '--active';
                        if (showtarget.getAttribute('data-showup-target') === showbtn.getAttribute('data-showup')) {
                            showtarget.classList.toggle(toggleClass);
                        }
                    }
                }
                showbtn.addEventListener('click', (e) => {
                    for (const showtarget of showtargets) {
                        const toggleClass = showtarget.classList[0] + '--active';
                        if (showtarget.getAttribute('data-showup-target') === showbtn.getAttribute('data-showup')) {
                            showtarget.classList.toggle(toggleClass);
                        }
                    }
                })
            }
        }

        if ((!this._findBtn) /* || (!this._backBtn ) */){
            return;
        }
        this._findBtn.addEventListener('click', (e) => {
            this._validateFields(e);
        });

        this._backBtn.addEventListener('click', (e) => {
            this._page1Holder.classList.remove('order-power__info--inactive');
            this._page2Holder.classList.remove('order-power__info-meter--active');
            if (document.querySelector('[data-power-invoicecheck]').checked) {
                this._sectionInvoice.classList.add('order-power__info--alt-addr--active')
            }
        });

        


        const form = document.getElementById('powerProduct--order');
        if (!form) {
            return;
        }
        form.addEventListener("submit", function (event) {
            event.preventDefault();
            let valid = true;
            //test
            let formData = new FormData(form); 
            for (let val of formData.entries()) {
                
            }   
        //    return;
            if (valid) {
                form.submit();
            }
        });      
    },
    _validateFields(e){
        e.preventDefault();
        const check = document.getElementById('agreeInfo');
        const emailFld = document.getElementById('orderPowerEmail');
        const addFld = document.getElementById("orderPowerAdd");
        const postFld = document.getElementById("orderPowerPost");
        const teleFld = document.getElementById("orderPowerTele");
        const dobFld = document.getElementById("orderPowerDob");

        let errorholders = document.getElementsByClassName('form__validation-error');
        for (const holder of errorholders) {
            holder.innerHTML = "";
        }
        let errorholder = null;
        let formvalid = true;
        if (check && !(check.checked)) {
            formvalid = false;
            let errorholder = check.parentElement.getElementsByClassName('form__validation-error')[0];
            if (!errorholder) {
                let errorNode = document.createElement('div');
                errorNode.innerHTML = 'Klikk på enig '
                errorNode.className = 'form__validation-error';
                check.parentNode.append(errorNode)
            } else {
                errorholder.innerHTML = 'Klikk på enig ';
            }
        }
      
        if (emailFld.value == "" || !(this._ValidateEmail(emailFld.value))) {
            formvalid = false;
            let errorholder = emailFld.parentElement.getElementsByTagName('label')[0];
            let error = !(this._ValidateEmail(emailFld.value)) ? 'Du har angitt en ugyldig e-postadresse' : 'fylle inn e-post adresse';
            if (errorholder) {
                if (!(errorholder.getElementsByTagName('span')[0])) {
                    errorholder.innerHTML += '<span class="form__validation-error">'+ error +'</span>';
                } else {
                    errorholder.getElementsByTagName('span')[0].innerHTML = error;
                }
            }
            else{
                let errorNode = document.createElement('span');
                errorNode.innerHTML = error
                errorNode.className = 'form__validation-error';
                emailFld.parentNode.append(errorNode);
            }
            errorholder.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" })
        }
        if(dobFld.value == ""){
            formvalid = false;
            let errorholder = dobFld.parentElement.getElementsByTagName('label')[0];
            let error = 'fyll inn fødselsdato';
            if (errorholder) {
                if (!(errorholder.getElementsByTagName('span')[0])) {
                    errorholder.innerHTML += '<span class="form__validation-error">'+error+'</span>';
                }
                else {
                    errorholder.getElementsByTagName('span')[0].innerHTML = error;
                }
            }

        }
        if (postFld.value == " ") {
            formvalid = false;
            let errorholder = postFld.parentElement.getElementsByTagName('label')[0];
            let error = 'fyll inn postnummer';
            if (errorholder) {
                if (!(errorholder.getElementsByTagName('span')[0])) {
                    errorholder.innerHTML += '<span class="form__validation-error">'+error+'</span>';
                }
                else {
                    errorholder.getElementsByTagName('span')[0].innerHTML = error;
                }
            }
            else{
                let errorNode = document.createElement('span');
                errorNode.innerHTML = 'fyll inn postnummer'
                errorNode.className = 'form__validation-error';
                postFld.parentNode.append(errorNode);
            }
            errorholder.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
        }
        if (addFld.value == " " || addFld.value == "") {
            formvalid = false;
            let error = 'fyll inn adresse';
            let errorholder = addFld.parentElement.getElementsByTagName('label')[0];
            if (errorholder) {
                if (!(errorholder.getElementsByTagName('span')[0])) {
                    errorholder.innerHTML += '<span class="form__validation-error">'+error+'</span>';
                } else {
                    errorholder.getElementsByTagName('span')[0].innerHTML = error;
                }
            }
            else {
                let errorNode = document.createElement('span');
                errorNode.innerHTML = 'fyll inn adresse'
                errorNode.className = 'form__validation-error';
                addFld.parentNode.append(errorNode);
            }
            errorholder.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
        }
        if (teleFld.value == "" || !(this._ValidateNumber(teleFld.value))) {
            formvalid = false;
            let errorholder = teleFld.parentElement.getElementsByTagName('label')[0];
            let error = 'ikke et gyldig telefonnummer';
            if (errorholder) {
                if (!(errorholder.getElementsByTagName('span')[0])) {
                    errorholder.innerHTML += '<span class="form__validation-error">'+error+'</span>';
                }
                else {
                    errorholder.getElementsByTagName('span')[0].innerHTML = error;
                }
            }
            else {
                let errorNode = document.createElement('span');
                errorNode.innerHTML = error;
                errorNode.className = 'form__validation-error';
                teleFld.parentNode.append(errorNode);
            }
            errorholder.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
        }
        if (formvalid) {
            this._page1Holder.classList.add('order-power__info--inactive');
            this._page2Holder.classList.add('order-power__info-meter--active');
            this._sectionInvoice.classList.remove('order-power__info--alt-addr--active')
            this._form.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" })
            const addressForm = document.getElementsByName('power[delivery-add]')[0];
            if (addressForm) {
                let labelHolder = addressForm.parentElement.getElementsByTagName('label')[0];
                if ((labelHolder.querySelector('span').innerHTML == "")||labelHolder.querySelector('span').innerHTML == " " || labelHolder.querySelector('span').innerHTML == null) {
                    const addFieldValue = document.getElementsByName('power[address]')[0];
                    addressForm.parentElement.getElementsByTagName('label')[0].innerHTML = addFieldValue.value;
                }
            }
            if (errorholder) {
                errorholder.style.display = 'none';
            }
        }
        else {
            return;
        }
    },
    _ValidateEmail(email) {
        return String(email)
            .toLowerCase()
            .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    },

    _ValidateNumber(phoneNumber) {
        let phoneNr = /^\d{8}$/;
        if (phoneNumber.match(phoneNr)) {
            return true;
        } else {
            return false;
        }
    }
}